/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import HotelManualEvent from '../../event/HotelManualEvent'
import { HouseManualState } from '../state/HouseManualState'

class HouseManualsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload
    switch (action.type) {
      case HotelManualEvent.fetchAll:
        return List(payload.house_manuals.map(model => new HouseManualState().mergeModel(model)))

      case HotelManualEvent.dragging:
        const item = state.get(payload.srcIndex)
        const tmp = state.splice(payload.srcIndex, 1)
        return tmp.splice(payload.targetIndex, 0, item)

      default:
        return state
    }
  }
}

export default new HouseManualsStore()
